import { BillItem as BaseBillItem, Channel as BaseChannel } from '../web-shared/types/billing';
import { Show } from './launch';

export type BillItemChannel = BaseChannel & {
  id?: string;
  topShows?: Show[];
  url?: string;
};

export type BillItem = BaseBillItem & {
  freeChannels: BillItemChannel[];
  channels: BillItemChannel[];
};

export enum SignupStep {
  CREATE = 1,
  /**
   * KU
   *
   * {@link AUTH} should only be used if /login/signup's payment wizard has an
   * inlined auth step
   */
  AUTH,
  PLAN,
  PAYMENT,
}

export type SelectablePlans = Array<BillItem>;
export type AddOns = Array<BillItem>;
export type SelectedAddOns = Array<BillItem>;
